module.exports = function(){
    var currentdate = new Date(); 
    return '' + currentdate.getDate() + (currentdate.getMonth()+1)  + currentdate.getFullYear() + currentdate.getHours()
}